import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '@/design-system';

export function NotFoundPage() {
  const { t: _t } = useTranslation();
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <EmptyState
        icon="bottle-empty"
        title="Korken er på"
        description="Siden du leter etter finnes ikke. Korken sitter godt i."
        action={
          <Link to="/cellar">
            <Button variant="primary" iconLeft="home">Til kjelleren</Button>
          </Link>
        }
      />
    </div>
  );
}
